import React from "react";
import { Link } from "react-router-dom";

const NewsPreviewNav = props => {
  const { orgSlug, postTitle } = props;
  return (
    <React.Fragment>
      <div className="events-page-post-nav">
        <div className="events-page-post-nav-list">
          <Link to="/" className="events-page-post-nav-list-link">
            Home
          </Link>
        </div>
        <div className="events-page-post-nav-list">
          <Link
            className="events-page-post-nav-list-link"
            to={`/company/${orgSlug}/news`}
          >
            News
          </Link>
        </div>

        <div className="events-page-post-nav-list">{postTitle}</div>
      </div>
    </React.Fragment>
  );
};

export default NewsPreviewNav;
